module.exports = (md) => {
  md.core.ruler.push('classed_td', (state) => {
    for (let i = 0; i < state.tokens.length; i++) {
      const token = state.tokens[i];
      if (token.type !== 'td_open' && token.type !== 'th_open') {
        continue;
      }

      const nextToken = state.tokens[i + 1];
      if (nextToken.type !== 'inline') {
        continue;
      }

      for (let j = 0; j < nextToken.children.length; j++) {
        const child = nextToken.children[j];
        if (child.type !== 'text') {
          continue;
        }

        const type = token.type.replace('_open', '');
        if (child.content.indexOf(`{${type}-class=`) !== 0) {
          continue;
        }

        const classRegExp = new RegExp(`^{${type}-class="([^"]+)"}`);
        const matches = child.content.match(classRegExp);
        if (!matches) {
          continue;
        }

        const classStr = matches[1];
        const content = child.content.replace(`{${type}-class="${classStr}"}`, '');

        if (!state.tokens[i].attrs) {
          state.tokens[i].attrs = [];
        }
        classStr.split(' ').forEach((className) => {
          state.tokens[i].attrs.push(['class', className]);
        });
        state.tokens[i + 1].children[j].content = content;
      }
    }
  });
};
